import Particle from "./primary/Particle.js";
import Animation from "./abstract/Animation.js";

export default class TitleAnimation extends Animation {
    isClicked = false;
    events = [];

    /**
     * @param {HTMLCanvasElement} canvas
     * @param {Particle[]} particles
     * @param {Function} updateParticle
     * @param {Function} drawParticle
     */
    constructor(canvas, particles) {
        super(canvas);
        this.defaultFill = "rgba(248, 253, 250, .3)";
        this.defaultStroke = "rgba(215, 215, 215, 1)";

        this.particles = particles;
        this.mouse = { x: null, y: null, radius: 0 };

        this.canvas.addEventListener("mousemove", (event) => {
            const correctedEventX = event.x - this.canvas.getBoundingClientRect().left;
            const correctedEventY = event.y - this.canvas.getBoundingClientRect().top;
            if(correctedEventX <= 14 || correctedEventY <= 14 || correctedEventX >= this.canvas.width - 14 || correctedEventY >= this.canvas.height - 14) {
                this.mouse = { x: null, y: null, radius: 0 };
                return
            }
            this.mouse.x = correctedEventX;
            this.mouse.y = correctedEventY;
            this.mouse.radius = 80;
        });

        this.canvas.addEventListener("mousedown", () => {
            this.isClicked = true;
            this.mouse.radius = 200;
        });
        this.canvas.addEventListener("mouseup", () => {
            this.isClicked = false;
            this.mouse.radius = 80;
        });
    }

    connectParticles() {
        this.ctx.lineWidth = 1;
        this.ctx.strokeStyle = this.defaultStroke;
        this.ctx.beginPath();

        for (let i = 0; i < this.particles.length; i++) {
            for (let j = i; j < this.particles.length; j++) {
                let dx = this.particles[i].x - this.particles[j].x;
                let dy = this.particles[i].y - this.particles[j].y;
                let distance = Math.sqrt(dx * dx + dy * dy);

                if (distance < 7 && distance > 1) {
                    this.ctx.moveTo(this.particles[i].x, this.particles[i].y);
                    this.ctx.lineTo(this.particles[j].x, this.particles[j].y);
                }
            }
        }

        this.ctx.stroke();
    }

    draw() {
        this.connectParticles();

        // this.ctx.beginPath();
        // for (let particle of this.particles) {
        //     this.ctx.moveTo(particle.x, particle.y);
        //     this.ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        // }

        // this.ctx.fillStyle = this.defaultFill;
        // this.ctx.fill();
    }

    /** @param {Particle} particle */
    getDistFromMouse(particle) {
        const dx = this.mouse.x - particle.x;
        const dy = this.mouse.y - particle.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        const maxDistance = this.mouse.radius;
        const forceDirectionX = dx / distance;
        const forceDirectionY = dy / distance;
        const force = (maxDistance - distance) / maxDistance;
        const directionX = forceDirectionX * force * particle.density;
        const directionY = forceDirectionY * force * particle.density;

        return {
            distance,
            directionX,
            directionY,
            radius: this.mouse.radius,
            isClicked: this.isClicked,
        };
    }

    update() {
        let lut = [[-1, 1], [-1, 1]];
        for (let particle of this.particles) {
            let movementInfos = this.getDistFromMouse(particle);
            if (movementInfos.distance <= movementInfos.radius) {
                particle.size = 4;

                if (movementInfos.isClicked) {
                    particle.x += movementInfos.directionX / 2;
                    particle.y += movementInfos.directionY / 2;
                } else {
                    particle.x -= movementInfos.directionX +
                        lut[Math.round(Math.random())][
                            Math.round(Math.random())
                        ];
                    particle.y -= movementInfos.directionY +
                        lut[Math.round(Math.random())][
                            Math.round(Math.random())
                        ];
                }
            } else {
                particle.size = 2;

                if (particle.x != particle.baseX) {
                    let dx = particle.x - particle.baseX;
                    particle.x -= dx / 10;
                }

                if (particle.y != particle.baseY) {
                    let dy = particle.y - particle.baseY;
                    particle.y -= dy / 10;
                }
            }
        }
    }
}
